
/* injects from baggage-loader */

'use strict';

import yellow1 from '_images/help/yellow1.png';
import yellow2 from '_images/help/yellow2.png';
import red1 from '_images/help/red1.png';
import red2 from '_images/help/red2.png';
import blue1 from '_images/help/blue1.png';
import blue2 from '_images/help/blue2.png';
import blue3 from '_images/help/blue3.png';

export default class DialogHelpController {
    constructor($log) {
        'ngInject';
        this.$log = $log;
    }

    $onInit(){
        switch(this.resolve.stage){
            case -1:
            this.ruleClass = "main";
            this.rules = [
            {
                txt: "<b>Explore</b> o quarto para encontrar uma das <b>3 fases</b> abaixo. Ao término de cada fase, você <b>ganhará</b> uma das <b>3 chaves</b> para desbloquear o <b>Tetraedo</b>."
            }];
            break;
            case 0:
            this.ruleClass = "img";
            this.rules = [
            {
                txt: "Utilize o mouse para arrastar as figuras e montar um desenho.", 
                back: blue1, 
            },
            {
                txt: "Quando terminar, aperte o botão <b>pronto</b>.", 
                back: blue2, 
            },
            {
                txt: "Responda as perguntas, observando a quantidade de figuras que você usou no desenho.", 
                back: blue3, 
            }];
            break;
            case 1:
            this.rules = [
            {
                txt: "Observe as sequências de figuras e identifique as figuras que completam cada sequência.", 
                back: red1, 
            },
            {
                txt: "Utilize o mouse para arrastar as figuras do inventário para o local correto.", 
                back: red2, 
            }];
            break;
            case 2:
            this.rules = [
            {
                txt: "Utilize o mouse para desvirar as cartas e encontrar os pares correspondentes.", 
                back: yellow1, 
            },
            {
                txt: "Identifique as formas espaciais e encontre as figuras do mundo real que se assemelham às formas e vice-versa.", 
                back: yellow2, 
            }];
            break;
        }
    }

    ok(){
      this.modalInstance.close(true);
  }

  cancel(){
      this.modalInstance.dismiss('cancel');
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/help/help.controller.js